/** Trigger a browser download. `type` is the Blob MIME type. */
export function downloadBlob(filename: string, contents: BlobPart, type: string): void {
  const blob = new Blob([contents], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadJsonFile(filename: string, data: unknown): void {
  downloadBlob(filename, `${JSON.stringify(data, null, 2)}\n`, 'application/json;charset=utf-8');
}
